var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"meeting",staticClass:"meeting"},[_c('div',{staticClass:"content"},[_c('meeting-room',{ref:"meetRoom",attrs:{"meetingId":_vm.meetingId,"sdkAppId":Number(_vm.sdkAppId),"userSig":_vm.userSig,"userId":_vm.userId,"roomId":_vm.roomId,"appSecretKey":_vm.appSecretKey},on:{"meetingInfo":_vm.getMeetingInfo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }